import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * @name PageScrollHandler
 * @author Ryan Gambrell
 * Purpose: Renders a component that handles automatic scrolling
 * to the top of the page on page redirects.
 * 
 * Previously, react-router-dom handled this but it has to be handled by us now. 
 */
export default function PageScrollHandler() {
    const { pathname } = useLocation();
    const firstRender = useRef(true);

    useEffect(() => {
        // Allow browser to restore scroll position on initial page load
        if (!firstRender.current) {
            window.scrollTo({ behavior: "instant", top: 0 });
        }

        firstRender.current = false;
    }, [pathname]);

    return null;
}